/**
 * L2d-P1 — mapping formulaire Admin « Personnel nécessaire ».
 * Valeurs métier stockées : null (Auto) | true (Oui) | false (Non).
 */

export const NECESSITE_PERSONNEL_OPTIONS = [
  {
    value: 'auto',
    label: 'Auto — recommandé',
    stored: null,
  },
  {
    value: 'oui',
    label: 'Oui, un membre du personnel est nécessaire',
    stored: true,
  },
  {
    value: 'non',
    label: 'Non, prestation autonome',
    stored: false,
  },
];

export const NECESSITE_PERSONNEL_HELP =
  'Auto suit le type de prestation : rendez-vous = personnel nécessaire ; créneau / réservation = autonome.';

/** Création : défaut Auto → null. */
export function defaultNecessitePersonnelForCreate() {
  return null;
}

/**
 * Édition : null → Auto ; true → Oui ; false → Non.
 * @param {boolean|null|undefined} stored
 * @returns {'auto'|'oui'|'non'}
 */
export function necessitePersonnelToSelectValue(stored) {
  if (stored === true) return 'oui';
  if (stored === false) return 'non';
  return 'auto';
}

/**
 * @param {'auto'|'oui'|'non'|string} selectValue
 * @returns {boolean|null}
 */
export function necessitePersonnelFromSelectValue(selectValue) {
  if (selectValue === 'oui') return true;
  if (selectValue === 'non') return false;
  return null;
}

/**
 * Libellé fiche / affichage optionnel.
 * @param {boolean|null|undefined} stored
 * @returns {'Auto'|'Oui'|'Non'}
 */
export function necessitePersonnelLabel(stored) {
  if (stored === true) return 'Oui';
  if (stored === false) return 'Non';
  return 'Auto';
}
